import { render } from "./PpcBAPrioritizedByCell.vue?vue&type=template&id=75d7e77a&scoped=true"
import script from "./PpcBAPrioritizedByCell.vue?vue&type=script&lang=js"
export * from "./PpcBAPrioritizedByCell.vue?vue&type=script&lang=js"

import "./PpcBAPrioritizedByCell.vue?vue&type=style&index=0&id=75d7e77a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d7e77a"]])

export default __exports__